import './quiz';
import { initChat } from './chat';

(function () {
  'use strict';

  var CFG = Object.assign({
    endpoint: '',
    phone: '',
    thanksUrl: '/',
    privacyUrl: '',
    keywordParam: 'utm_term',
    keywordMaxLength: 90,
    defaultTitle: 'Військовий адвокат',
    requireConsent: true,
    nativeSubmit: false,
    recaptchaSiteKey: '',
    recaptchaVerifyUrl: '',
    recaptchaNonce: ''
  }, window.LEAD_CONFIG || {});

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'loc_id'];
  var STORE_KEY = 'rost_utm';
  var LEADS_KEY = 'rost_leads';

  function readUtm() {
    var q = new URLSearchParams(location.search);
    var fromUrl = {}, has = false;
    UTM_KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v !== null && v !== '') { fromUrl[k] = v; has = true; }
    });
    if (has) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(fromUrl)); } catch (e) { }
      return fromUrl;
    }
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }

  function cleanKeyword(raw) {
    if (raw == null) return '';
    var v = String(raw).replace(/\+/g, ' ');
    try { v = decodeURIComponent(v); } catch (e) { }
    v = v.replace(/[<>]/g, ' ')
      .replace(/[\u0000-\u001F\u007F]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!v) return '';
    if (/[{}]/.test(v)) return '';
    if (/^https?:\/\//i.test(v)) return '';
    if (v.length > CFG.keywordMaxLength) return '';
    if (!/[a-zA-Zа-яА-ЯіїєґІЇЄҐ]/.test(v)) return '';
    return v.charAt(0).toUpperCase() + v.slice(1);
  }

  var utm = readUtm();
  var keyword = cleanKeyword(utm[CFG.keywordParam]);

  (function applyTitle() {
    var h1 = document.getElementById('heroTitle');
    var kw = document.querySelector('.js-h1-keyword');
    var def = document.querySelector('.js-h1-default');
    if (!h1 || !kw || !def) return;

    var shown = keyword || (def.textContent || CFG.defaultTitle).trim();

    if (keyword) {
      kw.textContent = keyword;
      kw.hidden = false;
      def.hidden = true;
      document.title = keyword;
      var og = document.querySelector('meta[property="og:title"]');
      if (og) og.setAttribute('content', keyword);
    }

    if (shown.length > 42) h1.classList.add('is-xlong');
    else if (shown.length > 24) h1.classList.add('is-long');

    document.body.setAttribute('data-title-source', keyword ? 'utm_term' : 'default');
  })();

  (function applyConfigLinks() {
    var digits = String(CFG.phone || '').replace(/[^\d+]/g, '');
    if (digits) {
      var pretty = digits;
      var m = digits.match(/^\+380(\d{2})(\d{3})(\d{2})(\d{2})$/);
      if (m) pretty = '+380 ' + m[1] + ' ' + m[2] + ' ' + m[3] + ' ' + m[4];
      document.querySelectorAll('.js-phone-link').forEach(function (a) { a.href = 'tel:' + digits; });
      document.querySelectorAll('.js-phone-text').forEach(function (el) { el.textContent = pretty; });
    }
    if (CFG.privacyUrl) {
      document.querySelectorAll('.js-privacy-link').forEach(function (a) { a.href = CFG.privacyUrl; });
    }
    document.querySelectorAll('.js-year').forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });
  })();

  function groupsOf(input) {
    var g = (input.getAttribute('data-groups') || '').trim();
    return g ? g.split(',').map(Number) : [];
  }
  function maxDigits(input) { return parseInt(input.getAttribute('data-max'), 10) || 15; }

  function formatDigits(digits, groups) {
    if (!groups.length) return digits;
    var out = [], i = 0;
    for (var k = 0; k < groups.length && i < digits.length; k++) {
      out.push(digits.slice(i, i + groups[k]));
      i += groups[k];
    }
    if (i < digits.length) out.push(digits.slice(i));
    return out.filter(Boolean).join(' ');
  }
  function placeholderFor(groups) {
    if (!groups.length) return '____ ___ ____';
    return groups.map(function (n) { return new Array(n + 1).join('_'); }).join(' ');
  }

  function stripTrunkZero(digits, form) {
    var ccEl = form && form.querySelector('.js-lf-cc-code');
    var cc = ccEl ? ccEl.textContent.trim() : '';
    if ((cc === '+380' || cc === '+48') && digits.charAt(0) === '0') return digits.replace(/^0+/, '');
    return digits;
  }

  document.querySelectorAll('.js-lf-phone').forEach(function (input) {
    input.addEventListener('input', function () {
      var digits = (input.value.match(/\d/g) || []).join('');
      digits = stripTrunkZero(digits, input.form).slice(0, maxDigits(input));
      input.value = formatDigits(digits, groupsOf(input));
      clearErr(input.form, 'phone');
    });
    input.addEventListener('keypress', function (e) {
      if (e.key && e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
    });
  });

  document.querySelectorAll('.js-lf-cc').forEach(function (cc) {
    var btn = cc.querySelector('.js-lf-cc-btn');
    var list = cc.querySelector('.js-lf-cc-list');
    var flag = cc.querySelector('.js-lf-cc-flag');
    var code = cc.querySelector('.js-lf-cc-code');
    var input = cc.closest('.lf-phone').querySelector('.js-lf-phone');
    var form = cc.closest('form');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = list.hidden;
      document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
      list.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    list.querySelectorAll('.lf-cc-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        code.textContent = opt.getAttribute('data-code');
        flag.src = opt.getAttribute('data-flag');
        input.setAttribute('data-max', opt.getAttribute('data-max'));
        input.setAttribute('data-groups', opt.getAttribute('data-groups'));
        setHidden(form, 'country_code', opt.getAttribute('data-country') || '');

        setHidden(form, 'country_dial', opt.getAttribute('data-code') || '');
        var digits = (input.value.match(/\d/g) || []).join('').slice(0, maxDigits(input));
        input.value = formatDigits(digits, groupsOf(input));
        input.placeholder = placeholderFor(groupsOf(input));
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        input.focus();
      });
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
  });

  function setHidden(form, name, value) {
    var el = form && form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (el) el.value = value == null ? '' : value;
  }

  function errBox(form, field) {
    return form.querySelector('.lf-err[data-for="' + field + '"]');
  }
  function setErr(form, field, msg) {
    if (!form) return;
    var box = errBox(form, field);
    if (box) { box.textContent = msg || ''; box.classList.toggle('is-on', !!msg); }

    if (field === 'consent') {
      var c = form.querySelector('.js-consent');
      if (c) c.classList.toggle('is-bad', !!msg);
    } else {
      var input = form.querySelector('[name="' + field + '"]');
      if (input) input.classList.toggle('is-bad', !!msg);
    }
  }
  function clearErr(form, field) { setErr(form, field, ''); }

  function getRecaptchaToken() {
    if (!CFG.recaptchaSiteKey || typeof window.grecaptcha === 'undefined') {
      return Promise.resolve('');
    }
    return new Promise(function (resolve) {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(CFG.recaptchaSiteKey, { action: 'lead_submit' })
          .then(resolve)
          .catch(function () { resolve(''); });
      });
    });
  }

  function verifyRecaptcha(token) {
    if (!CFG.recaptchaSiteKey) return Promise.resolve(true);

    var body = new URLSearchParams({
      action: 'advokat_verify_recaptcha',
      nonce: CFG.recaptchaNonce || '',
      token: token
    });

    return fetch(CFG.recaptchaVerifyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (result) { return !!(result && result.success); })
      .catch(function () { return false; });
  }

  function goThanks() {
    location.href = CFG.thanksUrl || '/';
  }

  function sendLead(lead, done) {
    console.info('[lead]', lead);
    try {
      var arr = JSON.parse(localStorage.getItem(LEADS_KEY) || '[]');
      arr.push(lead);
      localStorage.setItem(LEADS_KEY, JSON.stringify(arr.slice(-50)));
    } catch (e) { }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'generate_lead',
        lead_source: lead.source,
        lead_direction: lead.direction
      });
    }

    if (!CFG.endpoint) { done(); return; }

    var finished = false;
    var finish = function () { if (!finished) { finished = true; done(); } };
    setTimeout(finish, 2500);
    try {
      fetch(CFG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lead),
        keepalive: true
      }).then(finish, finish);
    } catch (e) { finish(); }
  }

  document.querySelectorAll('.js-lead-form').forEach(function (form) {

    UTM_KEYS.forEach(function (k) { setHidden(form, k, utm[k] || ''); });
    setHidden(form, 'keyword', keyword);
    setHidden(form, 'referer', document.referrer || '');
    setHidden(form, 'page', location.href);

    form.querySelectorAll('.js-topic').forEach(function (sel) {
      sel.addEventListener('change', function () {
        document.querySelectorAll('.js-topic').forEach(function (other) {
          if (other !== sel) other.value = sel.value;
          clearErr(other.form, 'topic');
        });
        syncPicked(sel.value);
      });
    });
    form.querySelectorAll('.js-consent input[type="checkbox"]').forEach(function (c) {
      c.addEventListener('change', function () { clearErr(form, 'consent'); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.busy === '1') return;

      var nameEl = form.querySelector('[name="customer_name"]');
      var phoneEl = form.querySelector('.js-lf-phone');
      var problemEl = form.querySelector('[name="problem"]');
      var consentEl = form.querySelector('.js-consent input[type="checkbox"]');
      var trapEl = form.querySelector('[name="website"]');
      var ccEl = form.querySelector('.js-lf-cc-code');
      var cc = ccEl ? ccEl.textContent.trim() : '+380';

      var topicEl = form.querySelector('.js-topic');
      var topic = topicEl ? topicEl.value.trim() : '';
      var topics = topic ? [topic] : [];

      var ok = true;

      var nameVal = nameEl ? nameEl.value.trim() : '';

      var digits = phoneEl ? (phoneEl.value.match(/\d/g) || []).join('') : '';
      var need = phoneEl ? maxDigits(phoneEl) : 9;
      if (!digits.length) {
        setErr(form, 'phone', 'Вкажіть номер телефону'); ok = false;
      } else if (cc === '+' ? digits.length < 7 : digits.length !== need) {
        setErr(form, 'phone', 'Номер має містити ' + (cc === '+' ? 'щонайменше 7' : need) + ' цифр'); ok = false;
      } else clearErr(form, 'phone');

      clearErr(form, 'topic');

      if (CFG.requireConsent && consentEl && !consentEl.checked) {
        setErr(form, 'consent', 'Потрібна згода на обробку персональних даних'); ok = false;
      } else clearErr(form, 'consent');

      if (!ok) {
        var bad = form.querySelector('.lf-input.is-bad, .lf-consent.is-bad');
        if (bad) {
          bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (bad.classList.contains('lf-input')) bad.focus({ preventScroll: true });
        }
        return;
      }

      var direction = keyword || topic;
      var directionSource = keyword ? 'utm_term' : (topic ? 'topics' : '');
      setHidden(form, 'direction', direction);
      setHidden(form, 'direction_source', directionSource);

      form.dataset.busy = '1';
      var btn = form.querySelector('.lf-submit');
      var btnLabelDefault = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Надсилаємо…'; }

      getRecaptchaToken().then(function (recaptchaToken) {
        return verifyRecaptcha(recaptchaToken).then(function (recaptchaOk) {
          if (!recaptchaOk) { throw new Error('recaptcha_failed'); }

          setHidden(form, 'recaptcha_token', recaptchaToken || '');

          if (CFG.nativeSubmit && form.getAttribute('action')) {
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'generate_lead',
                lead_source: form.getAttribute('data-source') || form.id,
                lead_direction: direction
              });
            }
            form.submit();
            return;
          }

          var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
          try { sessionStorage.setItem('rost_lead_ref', leadRef); } catch (err) { }

          sendLead({
            lead_ref: leadRef,
            source: form.getAttribute('data-source') || form.id,
            customer_name: nameVal,
            phone: cc + ' ' + phoneEl.value.trim(),
            country_code: (form.querySelector('[name="country_code"]') || {}).value || '',
            topics: topics,
            problem: problemEl ? problemEl.value.trim() : '',
            consent: !!(consentEl && consentEl.checked),
            direction: direction,
            direction_source: directionSource,
            keyword: keyword,
            utm: utm,
            referer: document.referrer || '',
            page: location.href,

            spam: !!(trapEl && trapEl.value),
            recaptcha_token: recaptchaToken || '',
            ts: new Date().toISOString()
          }, goThanks);
        });
      }).catch(function () {
        form.dataset.busy = '';
        if (btn) { btn.disabled = false; btn.textContent = btnLabelDefault; }
        setErr(form, 'phone', 'Не вдалося підтвердити, що ви не робот. Спробуйте ще раз.');
      });
    });
  });

  function headerOffset() {
    var h = document.querySelector('header.site');
    return (h ? h.offsetHeight : 0) + 16;
  }

  function scrollToEl(target, after) {
    if (!target) return;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - headerOffset(),
      behavior: 'smooth'
    });
    if (after) setTimeout(after, 550);
  }

  function nearestForm(fromEl) {
    var forms = [].slice.call(document.querySelectorAll('.js-lead-form'));
    if (!forms.length) return null;
    var base = fromEl.getBoundingClientRect().top;
    var below = forms.filter(function (f) { return f.getBoundingClientRect().top > base; });
    return below.length ? below[0] : forms[forms.length - 1];
  }

  function cardTopics(card) {
    return (card.getAttribute('data-topics') || '').split('|')
      .map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function syncPicked(value) {
    document.querySelectorAll('.js-pick').forEach(function (c) {
      c.classList.toggle('is-picked', !!value && cardTopics(c).indexOf(value) !== -1);
    });
  }

  document.querySelectorAll('.js-pick').forEach(function (card) {
    card.addEventListener('click', function () {
      var wanted = cardTopics(card);
      if (!wanted.length) return;

      var turningOff = card.classList.contains('is-picked');

      document.querySelectorAll('.js-topic').forEach(function (sel) {
        if (turningOff) {
          if (wanted.indexOf(sel.value) !== -1) sel.value = '';
        } else {
          sel.value = wanted[0];
          sel.classList.add('is-flash');
          setTimeout(function () { sel.classList.remove('is-flash'); }, 900);
          clearErr(sel.form, 'topic');
        }
      });

      syncPicked(turningOff ? '' : wanted[0]);

      if (turningOff) return;
      var form = nearestForm(card);
      scrollToEl(form, function () {
        var name = form && form.querySelector('[name="customer_name"]');
        if (name && window.matchMedia('(min-width: 700px)').matches) name.focus({ preventScroll: true });
      });
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target, id === '#lead' ? function () {
        var f = document.querySelector('#mainLeadForm [name="customer_name"]');
        if (f && window.matchMedia('(min-width: 700px)').matches) f.focus({ preventScroll: true });
      } : null);
    });
  });

  var mcta = document.getElementById('mobileCta');
  var heroForm = document.getElementById('heroLeadForm');
  var leadSection = document.getElementById('lead');
  if (mcta && heroForm) {

    var ticking = false;
    var syncCta = function () {
      ticking = false;
      var passedHero = heroForm.getBoundingClientRect().bottom < 0;
      var leadOpen = false;
      if (leadSection) {
        var r = leadSection.getBoundingClientRect();
        leadOpen = r.top < window.innerHeight && r.bottom > 0;
      }
      mcta.classList.toggle('is-on', passedHero && !leadOpen);
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncCta);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    window.addEventListener('load', onScroll);
    setTimeout(syncCta, 0);
  }

  initChat({
    utm: utm,
    keyword: keyword,
    getRecaptchaToken: getRecaptchaToken,
    verifyRecaptcha: verifyRecaptcha,
    sendLead: sendLead,
    goThanks: goThanks
  });

  var header = document.querySelector('header.site');
  function setHdr() {
    if (header) document.documentElement.style.setProperty('--hdr-h', header.offsetHeight + 'px');
  }
  setHdr();
  window.addEventListener('resize', setHdr);
  window.addEventListener('load', setHdr);
})();